import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faKey,
  faTag,
  faCircle,
  faInfoCircle,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/ui/modal";

const statusStyles = {
  active: "bg-green-600 text-white border-green-200",
  inactive: "bg-red-500 text-white border-red-200",
  ACTIVE: "bg-green-600 text-white border-green-200",
  INACTIVE: "bg-red-500 text-white border-red-200",
};

const ViewPermissionModal = ({ isOpen, onClose, permission }) => {
  if (!permission) return null;

  const status = permission.status?.toUpperCase() || "ACTIVE";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Permission details"
      footer={
        <div className="flex justify-end">
          <Button
            variant="outline"
            onClick={onClose}
            className="px-6 border-gray-300 hover:text-white hover:bg-orange-600"
          >
            Close
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        {/* Info Banner */}
        <div className="flex items-center gap-3 p-3 bg-gradient-to-r from-blue-50 to-white rounded-lg border border-blue-100">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
            <FontAwesomeIcon icon={faKey} className="text-blue-800 h-4 w-4" />
          </div>
          <div>
            <p className="text-sm text-gray-600 font-medium">
              Permission Information
            </p>
            <p className="text-xs font-semibold text-gray-900">
              {permission.display_name || permission.permission_name}
            </p>
          </div>
        </div>

        {/* Details Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
            <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
              <FontAwesomeIcon icon={faKey} className="text-blue-600 h-3 w-3" />
              Permission Name
            </p>
            <p className="text-sm font-semibold text-gray-900 mt-1">
              {permission.permission_name}
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
            <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
              <FontAwesomeIcon icon={faTag} className="text-blue-600 h-3 w-3" />
              Display Name
            </p>
            <p className="text-sm font-semibold text-gray-900 mt-1">
              {permission.display_name || "N/A"}
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
            <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
              <FontAwesomeIcon
                icon={faLayerGroup}
                className="text-blue-600 h-3 w-3"
              />
              Module
            </p>
            <p className="text-sm font-semibold text-gray-900 mt-1">
              <Badge
                variant="outline"
                className="bg-purple-600 text-white border-purple-200 font-normal"
              >
                {permission.module_name || "N/A"}
              </Badge>
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
            <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
              <FontAwesomeIcon
                icon={faCircle}
                className="text-blue-600 h-3 w-3"
              />
              Status
            </p>
            <div className="mt-1">
              <Badge
                variant="outline"
                className={`${statusStyles[permission.status] || statusStyles.active} border font-normal px-3 py-1 rounded-full text-xs flex items-center gap-1.5`}
              >
                <span
                  className={`inline-block w-1.5 h-1.5 rounded-full ${status === "ACTIVE" ? "bg-green-500" : "bg-red-500"}`}
                />
                {status}
              </Badge>
            </div>
          </div>
        </div>

        {/* Description Section */}
        {permission.description && (
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
            <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="text-blue-600 h-3 w-3"
              />
              Description
            </p>
            <p className="text-sm text-gray-700 mt-2 font-medium">
              {permission.description}
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ViewPermissionModal;
